import './search-bar.css'
import React, { useState } from 'react';

const SearchBar = ({searchSurvey}) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [searchBy, setSearchBy] = useState("project_name");

    return (
        <>
            <div id='search-container'>
                <h3 id="search-label">Browse surveys</h3>

                <div id="input-container">
                    <button id="search-button">
                        <i className="fas fa-search" onClick={() => {searchSurvey(searchTerm, searchBy)}}></i>
                    </button>
                    <input onChange={(e) => {
                        setSearchTerm(e.target.value)
                    }} placeholder="......">
                    </input>
                </div>
                {/* <div id="select-container">
                    <h3 id="search-label">Search by: </h3>
                    <select onChange={(e) => setSearchBy(columnNameToFieldNameDictionary[e.target.value])} name="filter">
                        <option>Project name</option>
                        <option>Project association</option>
                        <option>Project platform</option>
                        <option>Survey language</option>
                        <option>Target group</option>
                        <option>Deadline</option>
                    </select>
                </div> */}
            </div>
        </>
    )
}

const columnNameToFieldNameDictionary = {
    "Project Name": "project_name",
    "Project Association": "project_association",
    "Project Platform": "project_platform",
    "Survey Language": "survey_language",
    "Target Group": "target_group",
    "Deadline": "deadline"
}


export default SearchBar;